import { LoanTypeDropDown } from './components/LoanTypeDropDown';
import { ShowIf } from '../components/ShowIf';
import { BorrowerData } from './components/BorrowerData/BorrowerData';
import { BusinessPurposeDisclaimer } from './components/BorrowerData/components/BusinessPurposeDisclaimer';
import { useBorrowerLoanType } from '../../queries/BorrowerFields/CoreFields';

interface BorrowerFormProps {
    entryGuid: string | undefined;
    isReview?: boolean;
    set_disableWizardButtons?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const BorrowerForm: React.FC<BorrowerFormProps> = ({ entryGuid, isReview = false, set_disableWizardButtons = () => {} }) => {
    const [loanType] = useBorrowerLoanType();

    return (
        <>
            <BusinessPurposeDisclaimer isReview={isReview} />
            <LoanTypeDropDown
                entryGuid={entryGuid}
                required={true}
                isReview={isReview}
            />
            <ShowIf showIf={!!loanType}>
                <BorrowerData
                    loanType={loanType}
                    isReview={isReview}
                    set_disableWizardButtons={set_disableWizardButtons}
                    entryGuid={entryGuid}
                />
            </ShowIf>
        </>
    );
};
